export const globalDebug = () => {
  if (!process.env.DEBUG_INFO_ENABLED) {
    console.log = () => undefined;
    console.info = () => undefined;
    console.debug = () => undefined;
  }
};

export const getDocumentPathFromOfferSku = offerSku => {
  return offerSku
    .split('_')
    .slice(0, 2)
    .join('_C/');
};

export const scrollToNextSection = target => {
  target.current.scrollIntoView({
    block: 'start',
    behavior: 'smooth',
    inline: 'nearest'
  });
};

export const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

export const setStylesProperties = (data: any): any => {
  document.documentElement.style.setProperty('--active-field-background-color', data.activeFieldBackgroundColor);
  document.documentElement.style.setProperty('--background-color', data.backgroundColor);
  document.documentElement.style.setProperty('--background-image', 'url(' + data.backgroundImage + ') no-repeat top center');
  document.documentElement.style.setProperty('--clickable-color', data.clickableColor);
  document.documentElement.style.setProperty('--button-color', data.buttonColor);
  document.documentElement.style.setProperty('--fail-color', data.failColor);
  document.documentElement.style.setProperty('--field-information-color', data.fieldInformationColor);
  document.documentElement.style.setProperty('--form-background-color', data.formBackgroundColor);
  document.documentElement.style.setProperty('--hover-main-clickable-color', data.hoverMainClickableColor);
  document.documentElement.style.setProperty('--hover-secondary-clickable-color', data.hoverSecondaryClickableColor);
  document.documentElement.style.setProperty('--information-color', data.informationColor);
  document.documentElement.style.setProperty('--panel-opened-color', data.panelOpenedColor);
  document.documentElement.style.setProperty('--primary-color', data.primaryColor);
  document.documentElement.style.setProperty('--primary-client', data.primaryColor);
  document.documentElement.style.setProperty('--primary-fushia', data.primaryColor);
  document.documentElement.style.setProperty('--success-color', data.successColor);
  document.documentElement.style.setProperty('--text-color', data.textColor);
  document.documentElement.style.setProperty('--warning-color', data.warningColor);
  document.documentElement.style.setProperty('--secondary-client-light', data.hoverSecondaryClickableColor);

  return Promise.resolve();
};

export const formatText = (text: string) => {
  while (/\s/.test(text)) {
    const index = /\s/.exec(text);
    text = text.substring(0, index['index']) + ';' + text.substring(index['index'] + 1);
  }
  return text.replace(/;/g, ' ');
};

export const countriesList = [
  { name: 'Afghanistan', value: 'AF' },
  { name: 'Afrique du Sud', value: 'ZA' },
  { name: 'Albanie', value: 'AL' },
  { name: 'Algérie', value: 'DZ' },
  { name: 'Allemagne', value: 'DE' },
  { name: 'Andorre', value: 'AD' },
  { name: 'Angola', value: 'AO' },
  { name: 'Anguilla', value: 'AI' },
  { name: 'Antarctique', value: 'AQ' },
  { name: 'Antigua-et-Barbuda', value: 'AG' },
  { name: 'Antilles néerlandaises', value: 'AN' },
  { name: 'Arabie saoudite', value: 'SA' },
  { name: 'Argentine', value: 'AR' },
  { name: 'Arménie', value: 'AM' },
  { name: 'Aruba', value: 'AW' },
  { name: 'Australie', value: 'AU' },
  { name: 'Autriche', value: 'AT' },
  { name: 'Azerbaïdjan', value: 'AZ' },
  { name: 'Bahamas', value: 'BS' },
  { name: 'Bahreïn', value: 'BH' },
  { name: 'Bangladesh', value: 'BD' },
  { name: 'Barbade', value: 'BB' },
  { name: 'Bélarus', value: 'BY' },
  { name: 'Belgique', value: 'BE' },
  { name: 'Belize', value: 'BZ' },
  { name: 'Bénin', value: 'BJ' },
  { name: 'Bermudes', value: 'BM' },
  { name: 'Bhoutan', value: 'BT' },
  { name: 'Bolivie', value: 'BO' },
  { name: 'Bosnie-Herzégovine', value: 'BA' },
  { name: 'Botswana', value: 'BW' },
  { name: 'Brésil', value: 'BR' },
  { name: 'Brunéi Darussalam', value: 'BN' },
  { name: 'Bulgarie', value: 'BG' },
  { name: 'Burkina Faso', value: 'BF' },
  { name: 'Burundi', value: 'BI' },
  { name: 'Cambodge', value: 'KH' },
  { name: 'Cameroun', value: 'CM' },
  { name: 'Canada', value: 'CA' },
  { name: 'Cap-Vert', value: 'CV' },
  { name: 'Ceuta et Melilla', value: 'EA' },
  { name: 'Chili', value: 'CL' },
  { name: 'Chine', value: 'CN' },
  { name: 'Chypre', value: 'CY' },
  { name: 'Colombie', value: 'CO' },
  { name: 'Comores', value: 'KM' },
  { name: 'Congo-Brazzaville', value: 'CG' },
  { name: 'Corée du Nord', value: 'KP' },
  { name: 'Corée du Sud', value: 'KR' },
  { name: 'Costa Rica', value: 'CR' },
  { name: 'Côte d’Ivoire', value: 'CI' },
  { name: 'Croatie', value: 'HR' },
  { name: 'Cuba', value: 'CU' },
  { name: 'Danemark', value: 'DK' },
  { name: 'Diego Garcia', value: 'DG' },
  { name: 'Djibouti', value: 'DJ' },
  { name: 'Dominique', value: 'DM' },
  { name: 'Égypte', value: 'EG' },
  { name: 'El Salvador', value: 'SV' },
  { name: 'Émirats arabes unis', value: 'AE' },
  { name: 'Équateur', value: 'EC' },
  { name: 'Érythrée', value: 'ER' },
  { name: 'Espagne', value: 'ES' },
  { name: 'Estonie', value: 'EE' },
  { name: 'État de la Cité du Vatican', value: 'VA' },
  { name: 'États fédérés de Micronésie', value: 'FM' },
  { name: 'États-Unis', value: 'US' },
  { name: 'Éthiopie', value: 'ET' },
  { name: 'Fidji', value: 'FJ' },
  { name: 'Finlande', value: 'FI' },
  { name: 'France', value: 'FR' },
  { name: 'Gabon', value: 'GA' },
  { name: 'Gambie', value: 'GM' },
  { name: 'Géorgie', value: 'GE' },
  { name: 'Géorgie du Sud et les îles Sandwich du Sud', value: 'GS' },
  { name: 'Ghana', value: 'GH' },
  { name: 'Gibraltar', value: 'GI' },
  { name: 'Grèce', value: 'GR' },
  { name: 'Grenade', value: 'GD' },
  { name: 'Groenland', value: 'GL' },
  { name: 'Guadeloupe', value: 'GP' },
  { name: 'Guam', value: 'GU' },
  { name: 'Guatemala', value: 'GT' },
  { name: 'Guernesey', value: 'GG' },
  { name: 'Guinée', value: 'GN' },
  { name: 'Guinée équatoriale', value: 'GQ' },
  { name: 'Guinée-Bissau', value: 'GW' },
  { name: 'Guyana', value: 'GY' },
  { name: 'Guyane française', value: 'GF' },
  { name: 'Haïti', value: 'HT' },
  { name: 'Honduras', value: 'HN' },
  { name: 'Hongrie', value: 'HU' },
  { name: 'Île Bouvet', value: 'BV' },
  { name: 'Île Christmas', value: 'CX' },
  { name: 'Île Clipperton', value: 'CP' },
  { name: "Île de l'Ascension", value: 'AC' },
  { name: 'Île de Man', value: 'IM' },
  { name: 'Île Norfolk', value: 'NF' },
  { name: 'Îles Åland', value: 'AX' },
  { name: 'Îles Caïmans', value: 'KY' },
  { name: 'Îles Canaries', value: 'IC' },
  { name: 'Îles Cocos - Keeling', value: 'CC' },
  { name: 'Îles Cook', value: 'CK' },
  { name: 'Îles Féroé', value: 'FO' },
  { name: 'Îles Heard et MacDonald', value: 'HM' },
  { name: 'Îles Malouines', value: 'FK' },
  { name: 'Îles Mariannes du Nord', value: 'MP' },
  { name: 'Îles Marshall', value: 'MH' },
  { name: 'Îles Mineures Éloignées des États-Unis', value: 'UM' },
  { name: 'Îles Salomon', value: 'SB' },
  { name: 'Îles Turks et Caïques', value: 'TC' },
  { name: 'Îles Vierges britanniques', value: 'VG' },
  { name: 'Îles Vierges des États-Unis', value: 'VI' },
  { name: 'Inde', value: 'IN' },
  { name: 'Indonésie', value: 'ID' },
  { name: 'Irak', value: 'IQ' },
  { name: 'Iran', value: 'IR' },
  { name: 'Irlande', value: 'IE' },
  { name: 'Islande', value: 'IS' },
  { name: 'Israël', value: 'IL' },
  { name: 'Italie', value: 'IT' },
  { name: 'Jamaïque', value: 'JM' },
  { name: 'Japon', value: 'JP' },
  { name: 'Jersey', value: 'JE' },
  { name: 'Jordanie', value: 'JO' },
  { name: 'Kazakhstan', value: 'KZ' },
  { name: 'Kenya', value: 'KE' },
  { name: 'Kirghizistan', value: 'KG' },
  { name: 'Kiribati', value: 'KI' },
  { name: 'Koweït', value: 'KW' },
  { name: 'Laos', value: 'LA' },
  { name: 'Lesotho', value: 'LS' },
  { name: 'Lettonie', value: 'LV' },
  { name: 'Liban', value: 'LB' },
  { name: 'Libéria', value: 'LR' },
  { name: 'Libye', value: 'LY' },
  { name: 'Liechtenstein', value: 'LI' },
  { name: 'Lituanie', value: 'LT' },
  { name: 'Luxembourg', value: 'LU' },
  { name: 'Macédoine', value: 'MK' },
  { name: 'Madagascar', value: 'MG' },
  { name: 'Malaisie', value: 'MY' },
  { name: 'Malawi', value: 'MW' },
  { name: 'Maldives', value: 'MV' },
  { name: 'Mali', value: 'ML' },
  { name: 'Malte', value: 'MT' },
  { name: 'Maroc', value: 'MA' },
  { name: 'Martinique', value: 'MQ' },
  { name: 'Maurice', value: 'MU' },
  { name: 'Mauritanie', value: 'MR' },
  { name: 'Mayotte', value: 'YT' },
  { name: 'Mexique', value: 'MX' },
  { name: 'Moldavie', value: 'MD' },
  { name: 'Monaco', value: 'MC' },
  { name: 'Mongolie', value: 'MN' },
  { name: 'Monténégro', value: 'ME' },
  { name: 'Montserrat', value: 'MS' },
  { name: 'Mozambique', value: 'MZ' },
  { name: 'Myanmar', value: 'MM' },
  { name: 'Namibie', value: 'NA' },
  { name: 'Nauru', value: 'NR' },
  { name: 'Népal', value: 'NP' },
  { name: 'Nicaragua', value: 'NI' },
  { name: 'Niger', value: 'NE' },
  { name: 'Nigéria', value: 'NG' },
  { name: 'Niue', value: 'NU' },
  { name: 'Norvège', value: 'NO' },
  { name: 'Nouvelle-Calédonie', value: 'NC' },
  { name: 'Nouvelle-Zélande', value: 'NZ' },
  { name: 'Oman', value: 'OM' },
  { name: 'Ouganda', value: 'UG' },
  { name: 'Ouzbékistan', value: 'UZ' },
  { name: 'Pakistan', value: 'PK' },
  { name: 'Palaos', value: 'PW' },
  { name: 'Panama', value: 'PA' },
  { name: 'Papouasie-Nouvelle-Guinée', value: 'PG' },
  { name: 'Paraguay', value: 'PY' },
  { name: 'Pays-Bas', value: 'NL' },
  { name: 'Pérou', value: 'PE' },
  { name: 'Philippines', value: 'PH' },
  { name: 'Pitcairn', value: 'PN' },
  { name: 'Pologne', value: 'PL' },
  { name: 'Polynésie française', value: 'PF' },
  { name: 'Porto Rico', value: 'PR' },
  { name: 'Portugal', value: 'PT' },
  { name: 'Qatar', value: 'QA' },
  { name: 'R.A.S. chinoise de Hong Kong', value: 'HK' },
  { name: 'R.A.S. chinoise de Macao', value: 'MO' },
  { name: 'régions éloignées de l’Océanie', value: 'QO' },
  { name: 'République centrafricaine', value: 'CF' },
  { name: 'République démocratique du Congo', value: 'CD' },
  { name: 'République dominicaine', value: 'DO' },
  { name: 'République tchèque', value: 'CZ' },
  { name: 'Réunion', value: 'RE' },
  { name: 'Roumanie', value: 'RO' },
  { name: 'Royaume-Uni', value: 'GB' },
  { name: 'Russie', value: 'RU' },
  { name: 'Rwanda', value: 'RW' },
  { name: 'Sahara occidental', value: 'EH' },
  { name: 'Saint-Barthélémy', value: 'BL' },
  { name: 'Saint-Kitts-et-Nevis', value: 'KN' },
  { name: 'Saint-Marin', value: 'SM' },
  { name: 'Saint-Martin', value: 'MF' },
  { name: 'Saint-Pierre-et-Miquelon', value: 'PM' },
  { name: 'Saint-Vincent-et-les Grenadines', value: 'VC' },
  { name: 'Sainte-Hélène', value: 'SH' },
  { name: 'Sainte-Lucie', value: 'LC' },
  { name: 'Samoa', value: 'WS' },
  { name: 'Samoa américaines', value: 'AS' },
  { name: 'Sao Tomé-et-Principe', value: 'ST' },
  { name: 'Sénégal', value: 'SN' },
  { name: 'Serbie', value: 'RS' },
  { name: 'Serbie-et-Monténégro', value: 'CS' },
  { name: 'Seychelles', value: 'SC' },
  { name: 'Sierra Leone', value: 'SL' },
  { name: 'Singapour', value: 'SG' },
  { name: 'Slovaquie', value: 'SK' },
  { name: 'Slovénie', value: 'SI' },
  { name: 'Somalie', value: 'SO' },
  { name: 'Soudan', value: 'SD' },
  { name: 'Sri Lanka', value: 'LK' },
  { name: 'Suède', value: 'SE' },
  { name: 'Suisse', value: 'CH' },
  { name: 'Suriname', value: 'SR' },
  { name: 'Svalbard et Île Jan Mayen', value: 'SJ' },
  { name: 'Swaziland', value: 'SZ' },
  { name: 'Syrie', value: 'SY' },
  { name: 'Tadjikistan', value: 'TJ' },
  { name: 'Taïwan', value: 'TW' },
  { name: 'Tanzanie', value: 'TZ' },
  { name: 'Tchad', value: 'TD' },
  { name: 'Terres australes françaises', value: 'TF' },
  { name: "Territoire britannique de l'océan Indien", value: 'IO' },
  { name: 'Territoire palestinien', value: 'PS' },
  { name: 'Thaïlande', value: 'TH' },
  { name: 'Timor oriental', value: 'TL' },
  { name: 'Togo', value: 'TG' },
  { name: 'Tokelau', value: 'TK' },
  { name: 'Tonga', value: 'TO' },
  { name: 'Trinité-et-Tobago', value: 'TT' },
  { name: 'Tristan da Cunha', value: 'TA' },
  { name: 'Tunisie', value: 'TN' },
  { name: 'Turkménistan', value: 'TM' },
  { name: 'Turquie', value: 'TR' },
  { name: 'Tuvalu', value: 'TV' },
  { name: 'Ukraine', value: 'UA' },
  { name: 'Union européenne', value: 'EU' },
  { name: 'Uruguay', value: 'UY' },
  { name: 'Vanuatu', value: 'VU' },
  { name: 'Venezuela', value: 'VE' },
  { name: 'Viêt Nam', value: 'VN' },
  { name: 'Wallis-et-Futuna', value: 'WF' },
  { name: 'Yémen', value: 'YE' },
  { name: 'Zambie', value: 'ZM' },
  { name: 'Zimbabwe', value: 'ZW' }
];
export const insuredTypeList = [
  { name: '', value: 'T0' },
  { name: 'Téléphone', value: 'T1' }
];
export const deviceStateList = [
  { name: '', value: 'D0' },
  { name: 'Neuf', value: 'D1' },
  { name: 'occasion', value: 'D2' }
];
export const insuredModelList = [
  { name: '', value: 'T0' },
  { name: 'Iphone 15 / 512 Go / Noir', value: 'n1' }
];
export const insuredBrandList = [
  { name: '', value: 'T0' },
  { name: 'Apple', value: 'T3' }
];

export const insuredGoodTypeLabel = [
  { code: 'CJP', label: 'CONSOLE DE JEU VIDEO PORTABLE' },
  { code: 'PCJ', label: 'PETITE CONSOLE DE JEUX DE SALON' },
  { code: 'GCJ', label: 'GRANDE CONSOLE DE JEUX DE SALON' }
];
export const getCountryNameByValue = (value: string) => {
  const country = countriesList.find(c => c.value === value);
  return country ? country.name : null;
};

export function isEmptyObject(obj) {
  return !(typeof obj === 'object' && obj != null && Object.keys(obj).length !== 0);
}

export function isEmptyArray(array) {
  return !(array != null && Array.isArray(array) && array?.length > 0);
}
